import { Condition } from "../data/medication-condition-pairs";
import { DenialReason } from "../data/denial-reasons";
import { subDenialReasonOptionsByCondition } from "../data/sub-denial-reasons";

export const CONDITIONS_WITH_SUB_DENIAL_REASONS = [
  Condition.OBESITY,
  Condition.TYPE_2_DIABETES,
  Condition.CSID,
  Condition.OBSTRUCTIVE_SLEEP_APNEA,
  Condition.MASH,
];

export const SKIP_SUB_DENIAL_REASONS = [
  DenialReason.SITE_OF_CARE,
  DenialReason.NETWORK,
  DenialReason.FORCED_MEDICATION_SWITCH,
];

export const shouldShowSubDenialReasonField = (
  condition: string,
  denialReason: string,
): boolean => {
  if (!denialReason) {
    return false;
  }

  const hasConditionWithSubReasons = CONDITIONS_WITH_SUB_DENIAL_REASONS.some(
    (c) => c === condition,
  );

  const shouldSkipDenialReason = SKIP_SUB_DENIAL_REASONS.includes(
    denialReason as DenialReason,
  );

  return hasConditionWithSubReasons && !shouldSkipDenialReason;
};

export const getSubDenialReasonOptions = (
  condition: string,
): Array<{ value: string; label: string }> => {
  const hasConditionWithSubReasons = CONDITIONS_WITH_SUB_DENIAL_REASONS.some(
    (c) => c === condition,
  );

  if (!hasConditionWithSubReasons) {
    return [];
  }

  const availableSubDenialReasons =
    subDenialReasonOptionsByCondition[
      condition as
        | Condition.OBESITY
        | Condition.TYPE_2_DIABETES
        | Condition.CSID
        | Condition.OBSTRUCTIVE_SLEEP_APNEA
        | Condition.MASH
    ] || {};

  return Object.entries(availableSubDenialReasons).map(([key, label]) => ({
    value: key,
    label: label || key,
  }));
};
